/**
 * Text Field - embed module
 *
 * This module provides embeddable fields (location custom fields). This
 * includes a UI for selecting from a list of fields
 *
 * @author MattJS (matt@yext.com)
 */
goog.provide('yext.textfield.embed');

goog.require('yext');
goog.require('yext.storm.location.util');

yext.textfield.embed.embeds = [];

// One time lazy initialization flag
yext.textfield.embed.initialized = false;

/** @constructor */
yext.textfield.embed.TextFieldEmbed = function($field, options) {
  options = options || {};

  this.$ctx = $field.find('.js-add-embeddable-field');
  this.$input = $field.find('.js-text-field-input');
  this.$addEmbeddableField = $field.find('.js-add-embeddable-field');
  this.$globalEmbeddableFieldsCtx = $('.js-global-embeddable-fields');
  if (this.$globalEmbeddableFieldsCtx.length === 0) {
    console.error('did not find any embeddable fields');
  }

  this.embedDisplayValues = this.buildEmbedDisplayValuesMap();
  this.caretPosition = yext.getCaretPosition(this.$input);
  this.options = $.extend({}, yext.textfield.embed.TextFieldEmbed.DEFAULT_OPTIONS, options);
  this.enabled = true;

  this.buildEmbed();
  this.caratChange();
};

/** @const {!Object} */
yext.textfield.embed.TextFieldEmbed.DEFAULT_OPTIONS = {
  startWrap: '[[',
  endWrap: ']]',
};

/** @const {RegExp} */
yext.textfield.embed.TextFieldEmbed.BRACKETS_RE = /\[\[(.+?)\]\]/g;

/**
 * Build a map from embed key to display value
 *
 * @author MattJS (matt@yext.com)
 */
yext.textfield.embed.TextFieldEmbed.prototype.buildEmbedDisplayValuesMap = function() {
  var displayValues = {};
  this.$globalEmbeddableFieldsCtx.find('.js-embeddable-field-option').each(function() {
    var $this = $(this);
    displayValues[$this.data('value')] = $this.text();
  });
  return displayValues;
};

yext.textfield.embed.TextFieldEmbed.prototype.buildEmbed = function() {
  const self = this;

  this.$addEmbeddableField.find('.js-show-embeddable-fields').click(function(e) {
    if (!self.$embeddableFields) {
      self.$embeddableFields = self.$globalEmbeddableFieldsCtx.find('.js-embeddable-fields').clone();
      self.$ctx.append(self.$embeddableFields);
      self.bindKeyNavigation();
      self.$embeddableFields.on('click', '.js-embeddable-field-option', function() {
        self.updateInput(self.options.startWrap + $(this).data('value') + self.options.endWrap);
      });
    }
    self.$embeddableFields.show();
    return false; // Keep panel open
  });

  if (self.enabled) {
    self.$addEmbeddableField.show();
  }
};

/**
 * Bind event to listen for changes in the carat position and to store the
 * new value
 */
yext.textfield.embed.TextFieldEmbed.prototype.caratChange = function() {
  var self = this;

  this.$input.on('mouseup keyup change', function() {
    self.caretPosition = yext.getCaretPosition(self.$input);
  });
};

yext.textfield.embed.TextFieldEmbed.prototype.updateInput = function(value) {
  // To determine the correct new caret position, we need
  // to know the length of the translated string we are displaying
  var length = value.length;
  var actualValue = value.substring(2, value.length - 2);
  var translations = yext.getEmbeddedFieldTranslations();
  if (actualValue in translations) {
    length = translations[actualValue].length + 4;
  }
  var newCaretPosition = this.caretPosition + length;
  var leftHalf = this.$input.val().slice(0, this.caretPosition);
  var rightHalf = this.$input.val().slice(this.caretPosition);

  this.$input
    .val(leftHalf + value + rightHalf)
    .trigger('change');

  yext.setCaretPosition(this.$input, newCaretPosition);
  this.caretPosition = newCaretPosition;
};

yext.textfield.embed.TextFieldEmbed.prototype.close = function() {
  this.$embeddableFields && this.$embeddableFields.hide();
};

/**
 * Returns embedded field view markup
 *
 * @return {string} View mode markup
 */
yext.textfield.embed.TextFieldEmbed.prototype.viewMarkup = function(value) {
  return yext.storm.location.util.generateEmbeddedFieldBadges(value).replace(/\n/g, '<br>');
};

/**
 * Returns embedded field view markup using display values instead of embed keys
 *
 * @return {string} View mode markup
 */
yext.textfield.embed.TextFieldEmbed.prototype.viewMarkupWithDisplayValues = function(value) {
  var self = this;
  return String(value).replace(yext.textfield.embed.TextFieldEmbed.BRACKETS_RE, function(match, p1) {
    // NOTE(rbiswas) Incase there is a stored value not in the map, don't mark it up
    if (!self.embedDisplayValues[p1]) {
      return match;
    }
    return '<span class="badge-info">' + self.embedDisplayValues[p1] + '</span>';
  })
    .replace(/\n/g, '<br>');
};

/**
 * Toggles whether the embedd field is enabled
 * @param {boolean} enabled
 */
yext.textfield.embed.TextFieldEmbed.prototype.toggle = function(enabled) {
  this.enabled = enabled;
  this.$addEmbeddableField.toggle(enabled);
};

/**
 * Toggles whether the embed field is clickable
 * @param {boolean} enableClick If false, disables clicking on embed, and if true, enables.
 */
yext.textfield.embed.TextFieldEmbed.prototype.toggleClick = function(enableClick) {
  const btnParent = this.$addEmbeddableField;
  if (enableClick) {
    btnParent.removeClass('disable-click');
  } else {
    btnParent.addClass('disable-click');
  }
};


/**
 * Create an embed field object, store the reference and initialize the module
 * if necessary
 *
 * @param {!jQuery} $field
 * @param {!Object=} opts
 */
yext.textfield.embed.create = function($field, opts) {
  yext.textfield.embed.initialized || yext.textfield.embed.initialize();

  var embed = new yext.textfield.embed.TextFieldEmbed($field, opts);
  yext.textfield.embed.embeds.push(embed);
  return embed;
};


/**
 * Initialization for embed module
 */
yext.textfield.embed.initialize = function() {
  yext.textfield.embed.initialized = true;
  // Bind a click to the body that will close any open panels
  $('body').click(function() {
    for (var i = 0; i < yext.textfield.embed.embeds.length; i++) {
      yext.textfield.embed.embeds[i].close();
    }
  });
};

/**
 * Initialize keyboard navigation for dropdown.
 */
yext.textfield.embed.TextFieldEmbed.prototype.bindKeyNavigation = function() {
  const self = this;
  // Register space or enter as click, tab to next/prev element
  self.$embeddableFields.on('keydown', '.js-embeddable-field-option', function(e) {
    if (e.which === 32 || e.which === 13) { // space or enter
      $(this).click();
    } else if (!e.shiftKey && e.which === 9) { // tab
      if ($(this).next().length === 0) { // reached end of list
        self.close();
        $('.js-show-embeddable-fields').focus();
      }
      $(this).next().focus();
    } else if (e.shiftKey && e.which === 9) { // shift + tab
      if ($(this).prev().length === 0) { // at top of list
        self.close();
        $('.js-show-embeddable-fields').focus();
      }
      $(this).prev().focus();
    }
  });
};
